import React from 'react'
import s from './CityDescription.less'
import { selectDescription } from '../../store/address/address.selectors'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'

import TextShortener from '../genericComponents/TextShortener'
import { useSelector } from 'react-redux'
import { withFrenchLanguage } from '../i18n/i18nSite'

const CityDescription = () => {
  const description = useSelector(selectDescription)

  if (!description) return <></>

  return (
    <div className={s.description}>
      <TextShortener text={description} />
    </div>
  )
}

export default withEmptyFallbackErrorBoundary(withFrenchLanguage(CityDescription))
